import { IMPERSONATION_TOKEN_KEY } from "@/api/axios.ts";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function Impersonate() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      sessionStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
    }
    // Полная загрузка: App над роутом уже держит /me админа и в SPA-переходе перезапросит данные под токеном сотрудника.
    window.location.replace("/");
  }, []);

  return null;
}
